import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_CLASS_ENROLLMENTS_STATE } from "./consts";
import { ClassEnrollmentType } from "./models/ClassEnrollment";
import classEnrollmentsReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_CLASS_ENROLLMENTS_STATE, builder => {
  builder.register(PATH_TO_CLASS_ENROLLMENTS_STATE, classEnrollmentsReducer);
  import("../analytics");
});

// reducer
// actions
export {
  deleteClassEnrollment,
  receiveChildClassEnrollments,
  receiveClassEnrollment,
  receiveClassEnrollments
} from "./actions";
export {
  createClassEnrollmentActionFactory,
  deleteClassEnrollmentActionFactory,
  fetchAllClassesEnrollmentsActionFactory,
  fetchChildClassEnrollmentsActionFactory,
  fetchClassEnrollmentActionFactory
} from "./actions/meta";
// selectors
export {
  getClassEnrollment,
  getClassEnrollmentsByUserId,
  getClassNameForEnrollment,
  getEnrolledClasses,
  getEnrolledClassesWithCourse,
  getEnrolledClassIds,
  getEnrollmentClassUserIds,
  getEnrollmentCourseIds,
  getEnrollmentPrimaryCourseId,
  getIsClassManagedForEnrollment,
  getNumberOfEnrolledClasses,
  getTeacherNameForEnrollment,
  getTimeEnrolledInClass,
  hasEnrollmentsForCourse,
  hasNoEnrolledClasses,
  isEnrolledInClass,
  makeGetClassDropdownOptionsForCourse,
  makeGetSortedTeacherNamesForEnrollment
} from "./selectors";
export {
  getChildActiveEnrolledClasses,
  getChildClassEnrollment,
  getChildClassEnrollmentsByUserId,
  getChildEnrollmentCourseIds,
  getChildEnrollmentTeachers,
  getChildrenEnrolledClasses,
  getClassNameForChildEnrollment,
  getTeacherNameForChildEnrollment,
  getTimeChildEnrolledInClass
} from "./selectors/child-enrollment";
export {
  classEnrollmentsHaveFinishedFetching,
  getCreateClassEnrollmentsErrorMessage,
  getCreateClassEnrollmentsTimestamp,
  getDeleteClassEnrollmentsError,
  getDeleteClassEnrollmentsStarted,
  getDeleteClassEnrollmentsSuccess,
  getFetchChildClassEnrollmentsAreFetching,
  getFetchChildClassEnrollmentsErrored,
  getFetchChildClassEnrollmentsFinished,
  getFetchChildClassEnrollmentsSucceeded,
  getFetchClassEnrollmentError,
  getFetchClassEnrollmentsError,
  getFetchClassEnrollmentsLastFetched,
  getFetchClassEnrollmentsStarted,
  getFetchClassEnrollmentsSuccess,
  getFetchClassEnrollmentStarted,
  getFetchClassEnrollmentSuccess
} from "./selectors/meta";
export { classEnrollmentsReducer, PATH_TO_CLASS_ENROLLMENTS_STATE };
// types
export type { ClassEnrollmentType };
